import { Avatar, Button, Image, message, Tooltip } from "antd";
import classNames from "classnames";
import { useMemo } from "react";

import styles from "./index.less";

import HumanIcon from "@/assets/images/chat/human.svg";
import { ReactComponent as RefreshIcon } from "@/assets/images/chat/refresh.svg";
import { ReactComponent as CopyIcon } from "@/assets/images/chat/copy2.svg";
import { copyData } from "@packages/utils";

import FileMessage from "./messages/File";
import VideoMessage from "./messages/VideoMessage";
import VoiceMessage from "./messages/VoiceMessage";
import Text from "./messages/Text";
import { ChatMessageType } from "@/services/chat";
import { StreamResponseDataType } from "@/utils/streamFetch";

type ChatItemHumanProps = {
  msg: ChatMessageType;
  loading: boolean;
  onRefresh: () => void;
  streamResponseData?: StreamResponseDataType[];
};

const ChatItemHuman = ({
  msg,
  loading,
  onRefresh,
  streamResponseData,
}: ChatItemHumanProps) => {
  const totalTime = useMemo(() => {
    if (streamResponseData) {
      const maxEndTime = Math.max(
        ...streamResponseData.map((d) => d.endTime).filter((d) => !!d)
      );
      const minBeginTime = Math.min(
        ...streamResponseData.map((d) => d.beginTime).filter((d) => !!d)
      );

      if (
        Math.abs(maxEndTime) === Infinity ||
        Math.abs(minBeginTime) === Infinity
      )
        return 0;

      const time = (maxEndTime - minBeginTime) / 1000;
      return time;
    }
    return 0;
  }, [streamResponseData]);

  function renderMsg() {
    switch (msg.type) {
      case "text":
        return (
          <div className={styles["chat-item-ai-content"]}>
             <Text msg={msg} />
          </div>
        );
      case "image":
        return <Image src={msg.url} className={styles.img} />;
      case "file":
        return <FileMessage msg={msg} />;
      case "video":
        return <VideoMessage msg={msg} />;
      case "voice":
        return <VoiceMessage url={msg.url} />;
      default:
        return null;
    }
  }

  return (
    <div className={classNames(styles["chat-item"], styles["chat-item-human"])}>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-end",
        }}
        className={styles["message-box"]}
      >
        <div className={styles["message-container"]}>
          {renderMsg()}

          {!loading && streamResponseData && (
            <div className={styles["time-actions-container"]}>
              <div className={styles.time}>{`${totalTime}"`}</div>

              <div className={styles["action-area"]}>
                <Tooltip title="重新生成" placement="bottom">
                  <Button
                    type="text"
                    className="!w-[22px] !h-[22px]"
                    icon={<RefreshIcon />}
                    onClick={onRefresh}
                  />
                </Tooltip>

                <Tooltip title="复制" placement="bottom">
                  <Button
                    type="text"
                    className="!w-[22px] !h-[22px]"
                    icon={<CopyIcon />}
                    onClick={async () => {
                      if (msg.type === "text") {
                        await copyData(msg.messageOutput);
                        message.success("复制成功");
                      } else {
                        message.warning("非文本内容");
                      }
                    }}
                  />
                </Tooltip>
                {/* <div className={styles['action-divier']} /> */}
                {/* <Button type="text" icon={<DeleteIcon />} onClick={onDelete} /> */}
              </div>
            </div>
          )}

          {loading && (
            <>
              <div className={styles.loading}>
                <div />
                <div />
                <div />
                <div />
                <div />
              </div>
            </>
          )}
        </div>
      </div>
      <Avatar shape="square" src={HumanIcon} className={styles.avatar} />
    </div>
  );
};

export default ChatItemHuman;
